import React from 'react';

interface ErrorMessageProps {
  message: string;
  type?: 'inline' | 'card';
}

export const ErrorMessage: React.FC<ErrorMessageProps> = ({
  message,
  type = 'inline',
}) => {
  if (type === 'inline') {
    return (
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: '8px',
          marginTop: '6px',
          fontSize: '13px',
          color: '#dc2626',
        }}
      >
        <svg
          width="14"
          height="14"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          style={{ flexShrink: 0 }}
        >
          <circle cx="12" cy="12" r="10" />
          <line x1="12" y1="8" x2="12" y2="12" />
          <line x1="12" y1="16" x2="12.01" y2="16" />
        </svg>
        <span>{message}</span>
      </div>
    );
  }

  return (
    <div
      style={{
        background: 'linear-gradient(135deg, #fee2e2 0%, #fecaca 100%)',
        border: '2px solid #ef4444',
        borderRadius: '12px',
        padding: '16px',
        display: 'flex',
        alignItems: 'flex-start',
        gap: '12px',
        marginBottom: '16px',
      }}
    >
      <svg
        width="20"
        height="20"
        viewBox="0 0 24 24"
        fill="none"
        stroke="#dc2626"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        style={{ flexShrink: 0, marginTop: '2px' }}
      >
        <path d="m21.73 18-8-14a2 2 0 0 0-3.48 0l-8 14A2 2 0 0 0 4 21h16a2 2 0 0 0 1.73-3Z" />
        <line x1="12" y1="9" x2="12" y2="13" />
        <line x1="12" y1="17" x2="12.01" y2="17" />
      </svg>
      <div style={{ flex: 1 }}>
        <p style={{ margin: 0, color: '#7f1d1d', fontSize: '15px', fontWeight: '500' }}>
          {message}
        </p>
      </div>
    </div>
  );
};

interface ErrorWithRetryProps {
  message: string;
  onRetry: () => void;
}

export const ErrorWithRetry: React.FC<ErrorWithRetryProps> = ({
  message,
  onRetry,
}) => {
  return (
    <div
      style={{
        background: 'linear-gradient(135deg, #fee2e2 0%, #fecaca 100%)',
        border: '2px solid #ef4444',
        borderRadius: '16px',
        padding: '20px',
        textAlign: 'center',
      }}
    >
      <svg
        width="48"
        height="48"
        viewBox="0 0 24 24"
        fill="none"
        stroke="#dc2626"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        style={{ margin: '0 auto 16px', display: 'block' }}
      >
        <circle cx="12" cy="12" r="10" />
        <line x1="12" y1="8" x2="12" y2="12" />
        <line x1="12" y1="16" x2="12.01" y2="16" />
      </svg>
      <h3 style={{ margin: '0 0 8px', fontSize: '18px', fontWeight: '600', color: '#7f1d1d' }}>
        Coś poszło nie tak
      </h3>
      <p style={{ margin: '0 0 20px', fontSize: '14px', color: '#991b1b' }}>
        {message}
      </p>
      <button
        onClick={onRetry}
        style={{
          background: '#ef4444',
          color: 'white',
          border: 'none',
          borderRadius: '10px',
          padding: '12px 24px',
          fontSize: '15px',
          fontWeight: '600',
          cursor: 'pointer',
          transition: 'all 0.2s',
        }}
        onMouseEnter={(e) => {
          e.currentTarget.style.background = '#dc2626';
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.background = '#ef4444';
        }}
      >
        Spróbuj ponownie
      </button>
    </div>
  );
};
